import { TApplicationState } from "../store";
import { LOCATION_REDUCER_KEY, ILocationState } from "./reducer";
import { getRouteInfo } from "../routes";
import { TReducerSelector } from "../../ts/general";

const reducerState: TReducerSelector<ILocationState> = (state: TApplicationState) => state[LOCATION_REDUCER_KEY];

export const getRouteKey = (state: TApplicationState) => reducerState(state).type;

export const getPage = (state: TApplicationState) => getRouteInfo(getRouteKey(state)).page;